import React from "react";
import { useTheme } from "../../../../contexts/ThemeContext";

interface PdfPreviewProps {
  src: string;
  fileName: string;
}

const PdfPreview: React.FC<PdfPreviewProps> = ({ src, fileName }) => {
  const { theme } = useTheme();
  const isDarkMode = theme === "dark";

  // Hide navigation sidebar and toolbar for clean document viewing
  // Parameters: navpanes=0 hides sidebar, toolbar=0 hides top toolbar, view=FitH fits width
  const pdfUrl = `${src}#navpanes=0&toolbar=0&view=FitH`;

  return (
    <div className="flex flex-col h-full">
      <div className="flex-1 overflow-hidden">
        <iframe
          src={pdfUrl}
          title={fileName}
          className="w-full h-full border-0"
          style={{
            backgroundColor: isDarkMode ? "#111111" : "#ffffff",
          }}
        />
      </div>
    </div>
  );
};

export default PdfPreview;

